import { __assign, __rest } from "tslib";
import * as React from 'react';
import { CodeBlock } from './CodeBlock';
import { CodeInline } from './CodeInline';
export var Code = function (_a) {
    var children = _a.children, _b = _a.CodeBlockComponent, CodeBlockComponent = _b === void 0 ? CodeBlock : _b, _c = _a.CodeInlineComponent, CodeInlineComponent = _c === void 0 ? CodeInline : _c, props = __rest(_a, ["children", "CodeBlockComponent", "CodeInlineComponent"]);
    if (!children)
        return null;
    var isMultiline = children.toString().search(/\r?\n|\r/g) >= 0;
    if (isMultiline)
        return React.createElement(CodeBlockComponent, __assign({}, props), children);
    return React.createElement(CodeInlineComponent, __assign({}, props), children);
};
//# sourceMappingURL=Code.js.map